// Регистрация Stimulus-контроллеров. Перегенерация: ./bin/rails stimulus:manifest:update.
import { application } from "./application"

import RevealController from "./reveal_controller"
application.register("reveal", RevealController)

import NavController from "./nav_controller"
application.register("nav", NavController)

import CounterController from "./counter_controller"
application.register("counter", CounterController)

import MapController from "./map_controller"
application.register("map", MapController)

import AccGalleryController from "./acc_gallery_controller"
application.register("acc-gallery", AccGalleryController)

import PropertiesEditorController from "./properties_editor_controller"
application.register("properties-editor", PropertiesEditorController)

import ExpandableController from "./expandable_controller"
application.register("expandable", ExpandableController)

import WysiwygController from "./wysiwyg_controller"
application.register("wysiwyg", WysiwygController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import LightboxController from "./lightbox_controller"
application.register("lightbox", LightboxController)

import GalleryAdminController from "./gallery_admin_controller"
application.register("gallery-admin", GalleryAdminController)

import ProjectCardController from "./project_card_controller"
application.register("project-card", ProjectCardController)

import PhotoManagerController from "./photo_manager_controller"
application.register("photo-manager", PhotoManagerController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import CookieBannerController from "./cookie_banner_controller"
application.register("cookie-banner", CookieBannerController)

import AccessibilitySearchController from "./accessibility_search_controller"
application.register("accessibility-search", AccessibilitySearchController)
